import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useCallback, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { jobContextMenu } from './jobContextMenu';

export const JobList = ({ expr }) => {

  const rsrc = useRsrc();
  const entityListRef = useRef();

  const getContextMenuItems = (params) => {
    let contextMenus = entityListRef.current.getContextMenuItems(params);
    contextMenus.push(...jobContextMenu(rsrc, params));
    return contextMenus;
  }

  const { jobCat } = useParams();

  const augRowsReq = useCallback((rowsReq) => {
    // Standalone scenario, jobCat comes from the url params
    if (jobCat) {
      rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('cat', jobCat.toUpperCase()));
    }

    // In a tab, an arbitrary expression can be leveraged to filter the Jobs
    if (expr) {
      rowsReq.expr = ExprUtils.and(rowsReq.expr, expr);
    }
  }, [expr]);

  return (
    <EntityList
      ref={entityListRef}
      module="skdr"
      entity="JOB"
      augRowsReq={augRowsReq}
      gridOptions={{
        getContextMenuItems
      }} />
  );
}